import React from 'react';
import Paper from '@mui/material/Paper';
import withStyles from '@mui/styles/withStyles';

export default withStyles({})(({ className, classes, children, ...props }) => {
	return (
		<Paper className={`paper ${className || ''}`} {...props}>
			{children}
		</Paper>
	);
});
